import React, { Component } from 'react';
import Formulario from './ClientesForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Clientes extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, listarPaises, getModulo, parametrosEmpresa } = this.props;
        const id = match.params.id;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        parametrosEmpresa();
        listarPaises();
        getModulo(modulo[5],modulo[4]);
    }
    
    render(){
        const { registroCliente, modificarCliente, loader, lectura, 
            listaP, datos, modulo, listarListadoPrecios } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    registroCliente = {registroCliente}
                    modificarCliente = {modificarCliente}
                    crear = {crear}
                    lectura = {lectura}
                    obtenerPaises = { listaP }
                    datos = {datos}
                    modulo = {modulo}
                    listarListadoPrecios = {listarListadoPrecios}
                />
            </LoadMask>
        );
    }
}

export default Clientes
